<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">{{
        wordList.lbl_sales_summary_list
      }}</v-card-title>
      <v-tabs v-model="tab" hide-slider>
        <div class="tab_switch d-flex align-center">
          <v-tab
            :class="[tab === 'eachDay' ? 'tab_switch_active' : 'tab_switch_inactive', 'd-flex align-center justify-center rounded-pill']"
            value="eachDay"
            @click="onClickEachDayTab"
          >
            {{ wordList.lbl_tab_each_day }}
          </v-tab>
          <v-tab
            :class="[tab === 'eachShop' ? 'tab_switch_active' : 'tab_switch_inactive', 'ml-2 d-flex align-center justify-center rounded-pill']"
            value="eachShop"
            :disabled="disabledEachShopTab"
            @click="onClickEachShopTab"
          >
            {{ wordList.lbl_tab_each_shop }}
          </v-tab>
        </div>
      </v-tabs>
        <!-- 日毎タブ { -->
        <v-window v-model="tab">
          <v-window-item value="eachDay">
            <v-card-text>
              <v-card flat>
                <!-- 検索条件入力 { -->
                <v-expansion-panels v-model="panel" flat multiple class="br_1">
                  <v-expansion-panel class="bk_gray_3">
                    <v-expansion-panel-title
                      class="py-0 font-weight-bold bk_gray_3"
                      >{{ wordList.lbl_search }}</v-expansion-panel-title
                    >
                    <v-expansion-panel-text class="bk_gray_3">
                      <v-divider class="mb-9" />
                      <Form>
                        <v-card class="bk_gray_3 py-4" flat>
                          <v-card-text class="px-0 py-0">
                            <v-row>
                              <v-col cols="12" class="px-0 py-0">
                                <v-card class="bk_gray_3" flat>
                                  <v-card-title
                                    class="px-3 py-0 text-subtitle-2"
                                  >
                                    {{ wordList.lbl_summary_type }}
                                  </v-card-title>
                                  <v-card-text class="pl-2 pr-0 py-5">
                                    <v-row>
                                      <v-col class="py-0">
                                        <v-radio-group
                                          v-model="summeryTypeValues"
                                          inline
                                          mandatory
                                          class="pr-3 pl-2 d-flex"
                                          @update:model-value="
                                            onClickSummaryType($event.index)
                                          "
                                        >
                                          <v-radio
                                            v-for="item in summaryTypeRadioItems"
                                            :key="item.index"
                                            :label="item.item"
                                            :value="item"
                                            :disabled="item.disabled"
                                            color="indigo"
                                            density="compact"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <template v-if="summeryTypeValues.index === '2'">
                              <v-row>
                                <v-col class="py-0">
                                  <v-card class="bk_gray_3" flat>
                                    <v-card-title
                                      class="px-0 py-0 text-subtitle-2"
                                    >
                                      {{ wordList.lbl_shop_name }}
                                    </v-card-title>
                                    <v-card-text class="px-0 py-5">
                                      <v-row>
                                        <!-- 店舗名 -->
                                        <v-col class="py-0">
                                          <v-autocomplete
                                            v-model="shopSelectValues"
                                            density="compact"
                                            :items="shopListItems"
                                            item-title="name"
                                            item-value="shop_code"
                                            :label="wordList.lbl_shop_name"
                                            :placeholder="
                                              wordList.plc_selectbox
                                            "
                                            :no-data-text="
                                              wordList.lbl_no_data_text
                                            "
                                            :disabled="disabledShopSelect"
                                            bg-color="white"
                                            return-object
                                            variant="outlined"
                                            @update:model-value="onChangeShop"
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <!-- エリア名 -->
                                <v-col class="py-0">
                                  <v-card class="bk_gray_3" flat>
                                    <v-card-title
                                      class="px-0 py-0 text-subtitle-2"
                                    >
                                      {{ wordList.lbl_area_name }}
                                    </v-card-title>
                                    <v-card-text class="px-0 py-5">
                                      <v-row>
                                        <!-- エリア名 -->
                                        <v-col class="py-0">
                                          <v-autocomplete
                                            v-model="areaSelectValues"
                                            density="compact"
                                            :items="areaListItems"
                                            item-title="area_name"
                                            item-value="area_code"
                                            :label="wordList.lbl_area_name"
                                            :placeholder="
                                              wordList.plc_selectbox
                                            "
                                            :no-data-text="
                                              wordList.lbl_no_data_text
                                            "
                                            :disabled="
                                              shopSelectValues === null ||
                                              shopSelectValues.name.length == 0
                                            "
                                            bg-color="white"
                                            return-object
                                            variant="outlined"
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                            <v-row>
                              <v-col cols="12">
                                <v-card class="bk_gray_3" flat>
                                  <v-card-title
                                    class="px-0 py-0 text-subtitle-2"
                                  >
                                    {{ wordList.lbl_day_select }}
                                  </v-card-title>
                                  <v-card-text class="px-3 py-0">
                                    <v-row>
                                      <!-- 日付 -->
                                      <v-col
                                        cols="12"
                                        sm="6"
                                        class="pr-3 pl-2 d-flex"
                                      >
                                        <v-menu
                                          v-model="deliveryDateFromMenuEachDay"
                                          :close-on-content-click="false"
                                          :offset="[20, 0]"
                                          transition="scale-transition"
                                          location="bottom"
                                          min-width="auto"
                                          max-width="80 px"
                                        >
                                          <template #activator="{ props }">
                                            <Field
                                              v-slot="{ errors }"
                                              :name="
                                                wordList.lbl_delivery_date_from ||
                                                'delivery_date_from'
                                              "
                                              rules="max:10"
                                            >
                                              <v-text-field
                                                v-model="
                                                  searchConditionDeliveryDateFrom
                                                "
                                                :label="
                                                  wordList.lbl_delivery_date_from
                                                "
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                variant="outlined"
                                                density="compact"
                                                clearable
                                                v-bind="props"
                                                :error-messages="errors"
                                                bg-color="#fff"
                                              ></v-text-field>
                                            </Field>
                                          </template>
                                          <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                                            <v-date-picker
                                              v-datepicker-scroll
                                              v-model="
                                                searchConditionDeliveryDateFrom
                                              "
                                              hide-header
                                              show-adjacent-months
                                              view-mode="month"
                                              @update:model-value="
                                                onSelectDeliveryDateFrom
                                              "
                                            />
                                          </v-locale-provider>
                                        </v-menu>
                                        <p class="mt-3 mx-2">〜</p>
                                        <v-menu
                                          v-model="deliveryDateToMenuEachDay"
                                          :close-on-content-click="false"
                                          :offset="[40, 0]"
                                          transition="scale-transition"
                                          location="bottom"
                                          min-width="auto"
                                        >
                                          <template #activator="{ props }">
                                            <Field
                                              v-slot="{ errors }"
                                              :name="
                                                wordList.lbl_delivery_date_to ||
                                                'delivery_date_to'
                                              "
                                              rules="max:100"
                                            >
                                              <v-text-field
                                                v-model="
                                                  searchConditionDeliveryDateTo
                                                "
                                                :label="
                                                  wordList.lbl_delivery_date_to
                                                "
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                variant="outlined"
                                                density="compact"
                                                clearable
                                                v-bind="props"
                                                :error-messages="errors"
                                                bg-color="#fff"
                                              ></v-text-field>
                                            </Field>
                                          </template>
                                          <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                                            <v-date-picker
                                              v-datepicker-scroll
                                              v-model="
                                                searchConditionDeliveryDateTo
                                              "
                                              hide-header
                                              show-adjacent-months
                                              view-mode="month"
                                              @update:model-value="onSelectDeliveryDateTo"
                                            />
                                          </v-locale-provider>
                                        </v-menu>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row>
                              <!-- 受付状態 -->
                              <v-col class="py-0">
                                <v-card class="bk_gray_3" flat>
                                  <v-card-title
                                    class="px-0 py-0 text-subtitle-2"
                                  >
                                    {{ wordList.lbl_status }}
                                  </v-card-title>
                                  <v-card-text class="px-0 py-0">
                                    <v-row>
                                      <div
                                        v-for="item in deliveryStatusName"
                                        :key="item.id"
                                        class="pt-0 pr-3 pl-2 d-flex"
                                      >
                                        <v-checkbox
                                          v-model="statusSelectedItem"
                                          :value="item.id"
                                          :label="item.name"
                                        ></v-checkbox>
                                      </div>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              variant="flat"
                              color="primary"
                              class="px-16 mt-6"
                              :disabled="
                                summeryTypeValues.index === '2' &&
                                (!shopSelectValues ||
                                  shopSelectValues.shop_code === '')
                              "
                              @click="onClickSearch(false)"
                              ><v-icon>mdi-magnify</v-icon
                              >{{ wordList.lbl_search }}</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </Form>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- 検索条件入力 } -->
              </v-card>
            </v-card-text>
          </v-window-item>
          <!-- 店舗毎タブ { -->
          <v-window-item value="eachShop">
            <v-card-text>
              <v-card flat>
                <!-- 検索条件入力 { -->
                <v-expansion-panels
                  v-model="panel"
                  flat
                  multiple
                  class="br_1"
                >
                  <v-expansion-panel>
                    <v-expansion-panel-title
                      class="py-0 font-weight-bold bk_gray_3"
                      >{{ wordList.lbl_search }}</v-expansion-panel-title
                    >
                    <v-expansion-panel-text class="bk_gray_3">
                      <v-divider class="mb-9" />
                      <Form>
                        <v-card class="bk_gray_3" flat>
                          <v-card-text class="py-0">
                            <v-row>
                              <v-col cols="12">
                                <v-card class="bk_gray_3" flat>
                                  <v-card-title
                                    class="px-0 py-0 text-subtitle-2"
                                  >
                                    {{ wordList.lbl_day_select }}
                                  </v-card-title>
                                  <v-card-text class="px-3 py-0">
                                    <v-row>
                                      <!-- 日付 -->
                                      <v-col
                                        cols="12"
                                        sm="6"
                                        class="pr-3 pl-2 d-flex"
                                      >
                                        <v-menu
                                          v-model="deliveryDateFromMenuEachShop"
                                          :close-on-content-click="false"
                                          :offset="[20, 0]"
                                          transition="scale-transition"
                                          location="bottom"
                                          min-width="auto"
                                          max-width="80 px"
                                        >
                                          <template #activator="{ props }">
                                            <Field
                                              v-slot="{ errors }"
                                              :name="
                                                wordList.lbl_delivery_date_from ||
                                                'delivery_date_from'
                                              "
                                              rules="max:10"
                                            >
                                              <v-text-field
                                                v-model="
                                                  searchConditionDeliveryDateFrom
                                                "
                                                :label="
                                                  wordList.lbl_delivery_date_from
                                                "
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                variant="outlined"
                                                density="compact"
                                                clearable
                                                v-bind="props"
                                                :error-messages="errors"
                                                bg-color="#fff"
                                              ></v-text-field>
                                            </Field>
                                          </template>
                                          <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                                            <v-date-picker
                                              v-datepicker-scroll
                                              v-model="
                                                searchConditionDeliveryDateFrom
                                              "
                                              hide-header
                                              show-adjacent-months
                                              view-mode="month"
                                              @update:model-value="
                                                onSelectDeliveryDateFrom
                                              "
                                            />
                                          </v-locale-provider>
                                        </v-menu>
                                        <p class="mt-3 mx-2">〜</p>
                                        <v-menu
                                          v-model="deliveryDateToMenuEachShop"
                                          :close-on-content-click="false"
                                          :offset="[40, 0]"
                                          transition="scale-transition"
                                          location="bottom"
                                          min-width="auto"
                                        >
                                          <template #activator="{ props }">
                                            <Field
                                              v-slot="{ errors }"
                                              :name="
                                                wordList.lbl_delivery_date_to ||
                                                'delivery_date_to'
                                              "
                                              rules="max:100"
                                            >
                                              <v-text-field
                                                v-model="
                                                  searchConditionDeliveryDateTo
                                                "
                                                :label="
                                                  wordList.lbl_delivery_date_to
                                                "
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                variant="outlined"
                                                density="compact"
                                                clearable
                                                v-bind="props"
                                                :error-messages="errors"
                                                bg-color="#fff"
                                              ></v-text-field>
                                            </Field>
                                          </template>
                                          <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                                            <v-date-picker
                                              v-datepicker-scroll
                                              v-model="
                                                searchConditionDeliveryDateTo
                                              "
                                              hide-header
                                              show-adjacent-months
                                              view-mode="month"
                                              @update:model-value="onSelectDeliveryDateTo"
                                            />
                                          </v-locale-provider>
                                        </v-menu>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row>
                              <!-- 受付状態 -->
                              <v-col class="py-0">
                                <v-card class="bk_gray_3" flat>
                                  <v-card-title
                                    class="px-0 py-0 text-subtitle-2"
                                  >
                                    {{ wordList.lbl_status }}
                                  </v-card-title>
                                  <v-card-text class="px-0 py-0">
                                    <v-row>
                                      <div
                                        v-for="item in deliveryStatusName"
                                        :key="item.id"
                                        class="pt-0 pr-3 pl-2 d-flex"
                                      >
                                        <v-checkbox
                                          v-model="statusSelectedItem"
                                          :value="item.id"
                                          :label="item.name"
                                        ></v-checkbox>
                                      </div>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              variant="flat"
                              color="primary"
                              class="px-16 mt-6"
                              @click="onClickSearch(false)"
                              ><v-icon>mdi-magnify</v-icon
                              >{{ wordList.lbl_search }}</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </Form>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- 検索条件入力 } -->
              </v-card>
            </v-card-text>
          </v-window-item>
        </v-window>
      <table
        class="px-3"
        width="100%"
        cellpadding="3"
        cellspacing="2"
        border="0"
      >
        <tbody>
          <tr>
            <td width="70%" align="left">
              <span style="background-color: #ffbeda"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
              <span
                >&nbsp;引取後のキャンセルがある日付または便および合計の行はこの背景色で表示されます</span
              >
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 一覧表示(全店舗日別)  { -->
      <v-card v-if="selectAllShopByDayFlg" flat width="100%">
        <v-data-table
          v-if="selectAllShopByDayFlg"
          :items="allShopByDaylistArray"
          :loading="listLoading"
          :items-per-page="allShopByDaylistArray.length"
          hide-default-footer
          :headers="allShopByDayHeaders"
          :no-data-text="wordList.lbl_no_data_text"
        >
          <template #headers="{ columns }">
            <tr>
              <th
                v-for="column in columns"
                :key="column.key"
                :class="['text-no-wrap', getHeaderAlignClass(column.align)]"
                :style="column.width ? { width: column.width + 'px' } : undefined"
              >
                {{ column.title }}
              </th>
            </tr>
          </template>
          <template #body="{ items }">
            <tr v-for="(item, index) in items" :key="index">
              <td
                :class="getRow(item).className"
                :style="{
                  'background-color':
                    getRow(item).backGroundColor !== ''
                      ? getRow(item).backGroundColor
                      : '',
                }"
              >
                {{ getRow(item).deliveryDate }}
              </td>
              <td
                class="text-right"
                :style="{
                  'background-color':
                    getRow(item).backGroundColor !== ''
                      ? getRow(item).backGroundColor
                      : '',
                }"
              >
                {{ getRow(item).sales }}
              </td>
              <td
                class="text-right"
                :style="{
                  'background-color':
                    getRow(item).backGroundColor !== ''
                      ? getRow(item).backGroundColor
                      : '',
                }"
              >
                {{ getRow(item).orderCount }}
              </td>
              <td
                class="text-right"
                :style="{
                  'background-color':
                    getRow(item).backGroundColor !== ''
                      ? getRow(item).backGroundColor
                      : '',
                }"
              >
                {{ getRow(item).salesAverage }}
              </td>
              <td
                class="text-right"
                :style="{
                  'background-color':
                    getRow(item).backGroundColor !== ''
                      ? getRow(item).backGroundColor
                      : '',
                }"
              >
                {{ getRow(item).oriconCount }}
              </td>
              <td
                class="text-right"
                :style="{
                  'background-color':
                    getRow(item).backGroundColor !== ''
                      ? getRow(item).backGroundColor
                      : '',
                }"
              >
                {{ getRow(item).emptyCount }}
              </td>
            </tr>
          </template>
          <template #top>
            <div class="d-flex justify-space-between mt-9 mb-5">
              <div class="d-flex align-center flex-wrap"></div>
              <div v-if="!xs">
                <v-menu open-on-hover location="bottom">
                  <template #activator="{ props }">
                    <v-btn variant="text" color="black" v-bind="props" class="pr-0 pl-2">
                      アクション
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </template>
                  <v-list width="250" class="pl-5">
                    <v-list-item-title
                      style="cursor: pointer"
                      @click="onClickDownload"
                    >
                      <v-icon class="mr-2">mdi-cloud-download</v-icon
                      >CSVダウンロード
                    </v-list-item-title>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card>
      <!-- 一覧表示(全店舗店舗別)  { -->
      <v-card v-if="selectAllShopByShopFlg" flat width="100%">
        <v-data-table
          v-if="selectAllShopByShopFlg"
          :items="allShopByShoplistArray"
          :loading="listLoading"
          :items-per-page="allShopByShoplistArray.length"
          hide-default-footer
          :headers="allShopByShopHeaders"
          :no-data-text="wordList.lbl_no_data_text"
        >
          <template #headers="{ columns }">
            <tr>
              <th
                v-for="column in columns"
                :key="column.key"
                :class="['text-no-wrap', getHeaderAlignClass(column.align)]"
                :style="column.width ? { width: column.width + 'px' } : undefined"
              >
                {{ column.title }}
              </th>
            </tr>
          </template>
          <template #body="{ items }">
            <template v-for="(item, itemIndex) in items" :key="getRow(item).shopCode ?? itemIndex">
              <tr
                v-for="(byAreaOrder, index) in getRow(item).byAreaOrders"
                :key="index"
              >
                <td
                  v-if="index === 0"
                  class="text-center sales-padding"
                  :rowspan="getRow(item).byAreaOrders.length"
                  :style="{
                    'background-color':
                      getRow(item).backGroundColor !== ''
                        ? getRow(item).backGroundColor
                        : '',
                  }"
                >
                  {{ getRow(item).shopCode }}
                </td>
                <td
                  v-if="index === 0"
                  class="text-center sales-padding"
                  :rowspan="getRow(item).byAreaOrders.length"
                  :style="{
                    'background-color':
                      getRow(item).backGroundColor !== ''
                        ? getRow(item).backGroundColor
                        : '',
                  }"
                >
                  {{ getRow(item).shopName }}
                </td>
                <td
                  v-if="index === 0"
                  class="text-right sales-padding"
                  :rowspan="getRow(item).byAreaOrders.length"
                  :style="{
                    'background-color':
                      getRow(item).backGroundColor !== ''
                        ? getRow(item).backGroundColor
                        : '',
                  }"
                >
                  {{ getRow(item).sales }}
                </td>
                <td
                  v-if="index === 0"
                  class="text-right sales-padding"
                  :rowspan="getRow(item).byAreaOrders.length"
                  :style="{
                    'background-color':
                      getRow(item).backGroundColor !== ''
                        ? getRow(item).backGroundColor
                        : '',
                  }"
                >
                  {{ getRow(item).orderCount }}
                </td>
                  <td
                    class="text-center sales-padding"
                    :style="{
                      'background-color':
                        byAreaOrder.backGroundColor !== ''
                          ? byAreaOrder.backGroundColor
                          : '',
                    }"
                  >
                    {{ byAreaOrder.areaName }}
                  </td>
                  <td
                    class="text-center sales-padding"
                    :style="{
                      'background-color':
                        byAreaOrder.backGroundColor !== ''
                          ? byAreaOrder.backGroundColor
                          : '',
                    }"
                  >
                    {{ byAreaOrder.orderName }}
                  </td>
                  <td
                    class="text-right sales-padding"
                    :style="{
                      'background-color':
                        byAreaOrder.backGroundColor !== ''
                          ? byAreaOrder.backGroundColor
                          : '',
                    }"
                  >
                    {{ byAreaOrder.eachOrderCount }}
                  </td>
              </tr>
            </template>
          </template>
          <template #top>
            <div class="d-flex justify-space-between mt-9 mb-5">
              <div class="d-flex align-center flex-wrap"></div>
              <div v-if="!xs">
                <v-menu open-on-hover location="bottom">
                  <template #activator="{ props }">
                    <v-btn variant="text" color="black" v-bind="props" class="pr-0 pl-2">
                      アクション
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </template>
                  <v-list width="250" class="pl-5">
                    <v-list-item-title
                      style="cursor: pointer"
                      @click="onClickDownload"
                    >
                      <v-icon class="mr-2">mdi-cloud-download</v-icon
                      >CSVダウンロード
                    </v-list-item-title>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card>
      <!-- 一覧表示(店舗別日別)  { -->
      <v-card v-if="selectEachShopByDayFlg" flat>
        <div id="list-table">
          <v-data-table
            v-if="selectEachShopByDayFlg"
            class="my-table"
            :items="eachShopByDaylistArray"
            :loading="listLoading"
            :items-per-page="eachShopByDaylistArray.length"
            :headers="eachShopByDayHeaders"
            hide-default-footer
            :no-data-text="wordList.lbl_no_data_text"
          >
            <template #headers="{ columns }">
              <tr>
                <th
                  v-for="column in columns"
                  :key="column.key"
                  :class="['text-no-wrap', getHeaderAlignClass(column.align)]"
                  :style="column.width ? { width: column.width + 'px' } : undefined"
                >
                  {{ column.title }}
                </th>
              </tr>
            </template>
            <template #body="{ items }">
              <template v-for="(item, index) in items" :key="index">
                <tr>
                  <td
                    :class="getRow(item).className"
                    :style="{
                      'background-color':
                        getRow(item).backGroundColor !== ''
                          ? getRow(item).backGroundColor
                          : '',
                      width: 125 + 'px',
                    }"
                  >
                    {{ getRow(item).deliveryDate }}
                  </td>
                  <td
                    class="text-right"
                    :style="{
                      'background-color':
                        getRow(item).backGroundColor !== ''
                          ? getRow(item).backGroundColor
                          : '',
                    }"
                  >
                    {{ getRow(item).sales }}
                  </td>
                  <td
                    class="text-right"
                    :style="{
                      'background-color':
                        getRow(item).backGroundColor !== ''
                          ? getRow(item).backGroundColor
                          : '',
                    }"
                  >
                    {{ getRow(item).orderCount }}
                  </td>
                  <td
                    class="text-right"
                    :style="{
                      'background-color':
                        getRow(item).backGroundColor !== ''
                          ? getRow(item).backGroundColor
                          : '',
                    }"
                  >
                    {{ getRow(item).salesAverage }}
                  </td>
                  <td
                    class="text-right"
                    :style="{
                      'background-color':
                        getRow(item).backGroundColor !== ''
                          ? getRow(item).backGroundColor
                          : '',
                    }"
                  >
                    {{ getRow(item).oriconCount }}
                  </td>
                  <template
                    v-for="(delivery, deliveryIndex) in getRow(item).deliveries"
                    :key="deliveryIndex"
                  >
                    <td
                      class="text-right"
                      :style="{
                        'background-color':
                          getRow(item).backGroundColor !== ''
                            ? getRow(item).backGroundColor
                            : '',
                      }"
                    >
                      {{ delivery.sales }}
                    </td>
                    <td
                      class="text-right"
                      :style="{
                        'background-color':
                          getRow(item).backGroundColor !== ''
                            ? getRow(item).backGroundColor
                            : '',
                      }"
                    >
                      {{ delivery.orderCount }}
                    </td>
                    <td
                      v-if="delivery.isDeliveryGroup == 1"
                      class="text-right"
                      :style="{
                        'background-color':
                          getRow(item).backGroundColor !== ''
                            ? getRow(item).backGroundColor
                            : '',
                      }"
                    >
                      G
                    </td>
                    <td
                      v-else
                      class="text-right"
                      :style="{
                        'background-color':
                          getRow(item).backGroundColor !== ''
                            ? getRow(item).backGroundColor
                            : '',
                      }"
                    >
                      {{ delivery.availability }}
                    </td>
                  </template>
                </tr>
              </template>
            </template>
            <template #top>
              <div class="d-flex justify-space-between mt-9 mb-5">
                <div class="d-flex align-center flex-wrap"></div>
                <div v-if="!xs">
                  <v-menu open-on-hover location="bottom">
                    <template #activator="{ props }">
                      <v-btn variant="text" color="black" v-bind="props" class="pr-0 pl-2">
                        アクション
                        <v-icon>mdi-cog</v-icon>
                      </v-btn>
                    </template>
                    <v-list width="250" class="pl-5">
                      <v-list-item-title
                        style="cursor: pointer"
                        @click="onClickDownload"
                      >
                        <v-icon class="mr-2">mdi-cloud-download</v-icon
                        >CSVダウンロード
                      </v-list-item-title>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-card>
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <!-- ダウンロード中 ダイアログ { -->
    <v-dialog v-model="downloadingDialog" persistent width="40%">
      <v-card>
        <v-card-title>在庫移動・回収依頼ダウンロード</v-card-title>
        <v-card-text>
          <v-container style="height: 200px">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                ダウンロード中...
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                  color="deep-purple-accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- } ダウンロード中 ダイアログ -->
  </v-container>
</template>
<script setup lang="ts">
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import AlertDialog from "@/components/AlertDialog.vue";
import { DeliveryRequest } from "@/common/constant";
import { ref, computed } from "vue";
import { useDisplay } from "vuetify";
import { ja as vuetifyJa } from "vuetify/locale";
import type { ShopListItem } from "./types";
import { allShopByDayTableHeaders, allShopByShopTableHeaders } from "./constants";
import { useSalesSummaryUiState } from "./composables/useSalesSummaryUiState";
import { useSalesSummarySearchForm } from "./composables/useSalesSummarySearchForm";
import { useSalesSummaryFilterOptions } from "./composables/useSalesSummaryFilterOptions";
import { useSalesSummaryTable } from "./composables/useSalesSummaryTable";
import { useSalesSummaryDownload } from "./composables/useSalesSummaryDownload";
import { useSalesSummaryInit } from "./composables/useSalesSummaryInit";

defineRule("required", required);
defineRule("max", max);
configure({
  generateMessage: localize({
    ja,
  }),
});

const { xs } = useDisplay();

////////////////////////////////////////////////////////////////////////////////
// UI状態
////////////////////////////////////////////////////////////////////////////////
const {
  errdialog,
  errMessage,
  panel,
  overlay,
  downloadingDialog,
  listLoading,
  listDataTotalCount,
  dispAllShopByDaylist,
  dispAllShopByShoplist,
  dispEachShopByDaylist,
} = useSalesSummaryUiState();

////////////////////////////////////////////////////////////////////////////////
// 検索フォーム
////////////////////////////////////////////////////////////////////////////////
const {
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  deliveryDateFromMenuEachDay,
  deliveryDateToMenuEachDay,
  deliveryDateFromMenuEachShop,
  deliveryDateToMenuEachShop,
  onSelectDeliveryDateFrom,
  onSelectDeliveryDateTo,
  statusSelectedItem,
} = useSalesSummarySearchForm();

////////////////////////////////////////////////////////////////////////////////
// フィルターオプション・タブ・モード
////////////////////////////////////////////////////////////////////////////////

// 店舗
const shopListItems = ref<ShopListItem[] | null | undefined>(null);
const bufShopListItems = ref<ShopListItem[] | null | undefined>(null);
const shopFromAllCheckFlag = ref<"none" | "all">("none");
const shopToAllCheckFlag = ref<"none" | "all">("none");
const searchShopSelectValuesFrom = ref<string[]>([]);
const searchShopSelectValuesTo = ref<string[]>([]);
const shopSelectValuesFrom = ref<{ shop_code: string; name: string }[]>([]);
const shopSelectValuesTo = ref<{ shop_code: string; name: string }[]>([]);

//店舗名をdisableにするかのフラグ
const shopDisabledFlag = ref(true);

const {
  isOperatorGroupShop,
  tab,
  mode,
  selectAllShopByDayFlg,
  selectAllShopByShopFlg,
  selectEachShopByDayFlg,
  disabledEachShopTab,
  disabledShopSelect,
  summaryTypeRadioItems,
  summeryTypeValues,
  shopSelectValues,
  areaSelectValues,
  areaEditSelectValues,
  areaListItems,
  onClickSummaryType,
  switchToEachDayMode,
  switchToEachShopMode,
  onChangeShop,
} = useSalesSummaryFilterOptions();

////////////////////////////////////////////////////////////////////////////////
// テーブルデータ・API通信
////////////////////////////////////////////////////////////////////////////////
const {
  allShopByDaylistArray,
  allShopByShoplistArray,
  eachShopByDaylistArray,
  deliverySettingArray,
  listDeliveryTime,
  eachShopByDayTableHeaders,
  eachShopByDayHeaders,
  onClickSearch,
  toVuetifyHeaders,
  getRow,
  getHeaderAlignClass,
} = useSalesSummaryTable({
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  statusSelectedItem,
  shopSelectValues,
  areaSelectValues,
  mode,
  summeryTypeValues,
  errdialog,
  errMessage,
  dispAllShopByDaylist,
  dispAllShopByShoplist,
  dispEachShopByDaylist,
});

/**
 * 全店舗タブ @Click
 */
const onClickEachDayTab = async (): Promise<void> => {
  allShopByDaylistArray.value = [];
  allShopByShoplistArray.value = [];
  eachShopByDaylistArray.value = [];
  // タブ切替時に一覧データ表示フラグをリセットし、未検索状態のダウンロードを防止する
  dispAllShopByDaylist.value = false;
  dispAllShopByShoplist.value = false;
  dispEachShopByDaylist.value = false;
  switchToEachDayMode();
};

/**
 * 店舗毎タブ @Click
 */
const onClickEachShopTab = async (): Promise<void> => {
  allShopByDaylistArray.value = [];
  allShopByShoplistArray.value = [];
  eachShopByDaylistArray.value = [];
  // タブ切替時に一覧データ表示フラグをリセットし、未検索状態のダウンロードを防止する
  dispAllShopByDaylist.value = false;
  dispAllShopByShoplist.value = false;
  dispEachShopByDaylist.value = false;
  switchToEachShopMode();
};

const allShopByDayHeaders= computed(() => toVuetifyHeaders(allShopByDayTableHeaders));
const allShopByShopHeaders = computed(() => toVuetifyHeaders(allShopByShopTableHeaders));

/**
 * 配達ステータス名 定義
 */
const deliveryStatusName: { id: string; name: string }[] = DeliveryRequest.status;

////////////////////////////////////////////////////////////////////////////////
// ダウンロード
////////////////////////////////////////////////////////////////////////////////
const { onClickDownload } = useSalesSummaryDownload({
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  statusSelectedItem,
  shopSelectValues,
  areaSelectValues,
  mode,
  summeryTypeValues,
  errdialog,
  errMessage,
  overlay,
  downloadingDialog,
  listDataTotalCount,
  dispAllShopByDaylist,
  dispAllShopByShoplist,
  dispEachShopByDaylist,
});

////////////////////////////////////////////////////////////////////////////////
// 店舗権限の場合の初期表示
////////////////////////////////////////////////////////////////////////////////
const initDisplayByShopAuth = (code: string, name: string): void => {
  disabledEachShopTab.value = true;
  summeryTypeValues.value = summaryTypeRadioItems[1];
  onClickSummaryType("2");

  shopSelectValues.value.shop_code = code;
  shopSelectValues.value.name = name;

  onChangeShop();

  disabledShopSelect.value = true;
  summaryTypeRadioItems[0].disabled = true;
};

////////////////////////////////////////////////////////////////////////////////
// 初期化
////////////////////////////////////////////////////////////////////////////////
const { wordList } = useSalesSummaryInit({
  errdialog,
  errMessage,
  shopListItems,
  bufShopListItems,
  shopSelectValuesFrom,
  shopSelectValuesTo,
  searchShopSelectValuesFrom,
  searchShopSelectValuesTo,
  shopFromAllCheckFlag,
  shopToAllCheckFlag,
  shopDisabledFlag,
  summeryTypeValues,
  summaryTypeRadioItems,
  isOperatorGroupShop,
  initDisplayByShopAuth,
  onClickSummaryType,
  onClickSearch,
});
</script>

<style>
#list-table {
}
#list-table table tr td {
  white-space: nowrap;
  text-align: center;
  align: center;
}
</style>

<style scoped></style>
